import React from 'react'
import Dialog from 'components/dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useGroupEventTemplateOptions } from 'components/group-events/form-option-hooks'
import GroupEventTemplateCard, {
  SuggestEventTemplateCard,
} from './group-event-template-card'

const GroupEventTemplatesList = ({ onCreateClick }) => {
  const groupEventTemplates = useGroupEventTemplateOptions()
  return (
    <>
      {groupEventTemplates.map(template => (
        <Grid key={template.title} item lg={4} md={6} sm={12} xs={12}>
          <GroupEventTemplateCard
            event={template}
            callToAction="Use template"
            onCreateClick={onCreateClick}
          />
        </Grid>
      ))}
      <Grid item lg={4} md={6} sm={12}>
        <SuggestEventTemplateCard onSuggestClick={onCreateClick} />
      </Grid>
    </>
  )
}

const CreateFromTemplateDialog = ({ trigger }) => {
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'))
  return (
    <Dialog
      trigger={trigger}
      maxWidth="lg"
      fullWidth
      fullScreen={isMobile}
      showCloseButton
    >
      {({ closeDialog }) => {
        return (
          <>
            <DialogTitle>
              Create From Template
              <Typography variant="body1">
                Select a template to get started. As you progress through the
                event creation wizard, feel free to edit the event information
                as you see fit.
              </Typography>
            </DialogTitle>
            <DialogContent dividers>
              <Grid container spacing={4}>
                <GroupEventTemplatesList onCreateClick={closeDialog} />
              </Grid>
            </DialogContent>
          </>
        )
      }}
    </Dialog>
  )
}

export default CreateFromTemplateDialog
